import { UtilityFunctionsService } from './utility-functions.service';
import { ICardCollection, DtoICollection, DtoICard, LikesResponseDto, ILikedUserData } from './../../models/collection';
import { MockDataService } from 'src/app/shared/providers/mock-data.service';
import { ICardLoadProgress, ICardLoadProgressProcessed, PRELOAD_DIRECTION, ModelCardRendered, ModelCardRenderedSelection, ICardExtended, StripeSubscriptionData, SUBSCRIPTION_STATUS, UserSubscriptionStatusDto, StripePrices, IAiDescriptionResponse } from './../../models/card';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Subscription, lastValueFrom } from 'rxjs';
import { CARD_TYPE, ICard, CARD_PURCHASE_STATUS } from 'src/app/models/card';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FirebaseAuthService } from './firebase-auth.service';
import { SettingsService } from './settings.service';
import { IappurchaseService } from './iappurchase.service';
import { RollbarService, CustomRollbar } from './rollbarlog.service';
import { User } from 'firebase/auth';
import { processCardsDtoUnified, convertCardsToDtoCards } from './processors/cards-dto-processor';
import { processDraftCollectionDtoResponse, convertCollectionToDtoCollection, processCollectionDtoResponse } from './processors/collections-dto-processor';

export interface AiCollectionInitAssetRequestDto {
  asset_id: string;
  title: string;
  position: number;
  original_url_web: string;
  original_url_app: string;
}

export interface AiCollectionInitRequestDto {
  title: string;
  assets: AiCollectionInitAssetRequestDto[];
  user_id?: string;
}

export interface AiCollectionInitResponseAssetDto {
  asset_id: string;
  model_id: string;
  poster_app: string;
  poster_web: string;
}

export interface AiCollectionInitResponseDto {
  collection_id: string;
  share_id?: string;
  shareId?: string;
  assets: AiCollectionInitResponseAssetDto[];
}

@Injectable({
  providedIn: 'root'
})
export class CardsService {
  public usdzHref: string = 'blank';

  private currentVisibleCard: ICard;
  private lastCollectionCard: ICard;

  public isFullscreenPreviewVisible: boolean = false;
  public currentCardSubject: Subject<ICard> = new Subject();
  public moreBtnSubject: Subject<ICard> = new Subject();
  public lessBtnSubject: Subject<any> = new Subject();
  public fullscreenPreviewSubject: Subject<boolean> = new Subject();
  public onApplicationActivationSubject: Subject<ICard> = new Subject();
  public onViewsRefreshRequested: Subject<void> = new Subject();
  public onCardChangedInVisibleZone: Subject<ICard[]> = new Subject();
  public stripeSubscriptionPrices: StripePrices[];

  public initStartTime: number;
  public initHomePageStartTime: number;
  public homeFeedGetTime: number;
  public homeBasicInitTime: number;

  public collectionDetailsInitTimeStart: number;
  public collectionDetailsInitTimeEnd: number;

  public modelFeedInitStart: number;
  public modelFeedInitEnd: number;

  public cardProgressStats: ICardLoadProgress[] = [];

  private preloadCardsArray: HTMLVideoElement[];

  public isReversePreloadDirectionSet: boolean = false;
  private lastTriggered: Date | null = null;

  // REFACTOR LATER !!!!!

  public onCollectionFeedDataRecieved: Subject<ICardCollection[]> = new Subject();
  public firebaseAuthSubscription: Subscription;
  public currentUser: User;
  public feedCollectionCardsSource: ICardCollection[];
  isLongResponseLoading: boolean;

    // eslint-disable-next-line max-len
  constructor(
    private http: HttpClient,
    public firebaseAuth: FirebaseAuthService,
    public settingsService: SettingsService,
    public utilityService: UtilityFunctionsService,
    public mockDataService: MockDataService,
    public iappurchaseService: IappurchaseService,
    @Inject(RollbarService) private rollbar: CustomRollbar
    ) {
      this.getHrefUsdzSample().then((refUrl)=>{
      this.usdzHref = refUrl
      })
    }

public async collectionFeedInit(): Promise<void> {
  await new Promise<void>(async (resolve, reject) => {
      if(this.firebaseAuth.currentUser) {
        await this.doFullAuth(this.firebaseAuth.currentUser);
        this.setSubForStatusSubscription();
        resolve();
      } else {
        // this.firebaseAuth.firebaseSignInAnonymously();
        try {
          this.getHomeFeed({unauth: true}).then((resp) => {
            this.feedCollectionCardsSource = resp;
            this.onCollectionFeedDataRecieved.next(this.feedCollectionCardsSource);

          })
        } catch (error) {
        }
        this.firebaseAuthSubscription = this.firebaseAuth.firebaseUser.subscribe(async (usr) => {
          await this.doFullAuth(usr);
          // getting STRIPE for web payments
          if(environment.type === 'web') {
            this.getStripeSubscriptions().then((resp: StripeSubscriptionData[]) => {
              let targetPrices: StripePrices[];
              targetPrices = resp.find((el) => el.is_actual)?.prices;
              if(targetPrices === undefined) targetPrices = resp[0].prices;

              this.stripeSubscriptionPrices = targetPrices;
              console.log('getStripeSubscriptions: ', targetPrices);
            });
          }

          this.firebaseAuthSubscription.unsubscribe();
          this.setSubForStatusSubscription();
          resolve();
        });
      }
  });

  this.feedCollectionCardsSource = await this.getHomeFeed();
  this.onCollectionFeedDataRecieved.next(this.feedCollectionCardsSource);
}


public checkUserSubscriptionStatus(): SUBSCRIPTION_STATUS {
  return this.firebaseAuth.currentUser.subscriptionStatus
}

public setSubForStatusSubscription(): Promise<SUBSCRIPTION_STATUS> {
  return new Promise<SUBSCRIPTION_STATUS>((resolve, reject) => {
    console.log('****** Requesting user subscription / membership status ')
    this.getUserSubscriptionStatusRequest().then((resp: UserSubscriptionStatusDto) => {
      this.firebaseAuth.patch3DWayUser(resp);
      resolve(resp.user_status);
    }).catch(err => {
      // Check for Safari IndexedDB error
      const isSafariIndexedDbError =
        err && err.message && err.message.includes('Error looking up record in object store by key range');
      if (isSafariIndexedDbError) {
        console.warn('Safari IndexedDB error encountered, silently handling the subscription / membership check.');
      } else {
        this.utilityService.showErrorSnackBar(err, 700);
        setTimeout(() => {
          this.utilityService.showImportantErrorSnackBar('Something wrong with checking your subscription / membership status, please contact support', 700);
          reject(err);
        }, 1000);
      }
    })
  });
}

public async getCollectionFeed(): Promise<ICardCollection[]> {
  if(this.feedCollectionCardsSource) {
    return new Promise((res, reject) => {
      res(JSON.parse(JSON.stringify(this.feedCollectionCardsSource)));
    });
  } else {
    return new Promise((res, reject) => {
      const sub: Subscription = this.onCollectionFeedDataRecieved.subscribe((data) => {
        res(JSON.parse(JSON.stringify(this.feedCollectionCardsSource)));
        sub.unsubscribe();
      })
    });

  }
}

public convertCollectionsToCardsFeed(col: ICardCollection[]): ICard[] {
  let cards: ICard[] = []
  cards = col.map(collection => {
    return {
      id: collection.collectionId,
      cardSharingId: collection.collectionSharingId,
      cardPosterMobile: collection.collectionPosterMobile,
      cardContentMobile: collection.collectionContentMobile,
      cardPosterWeb: collection.collectionPosterWeb,
      cardContentWeb: collection.collectionContentWeb,
      cardType: CARD_TYPE.COLLECTION,
      cardAuthor: collection.collectionAuthor,
      cardTitle: collection.collectionTitle,
      cardCategory: 'N/A',
      modifiedDate: collection.updated,
      cardDescription: collection.collectionDescription,
      cardPrice: 0,
      purchaseStatus: CARD_PURCHASE_STATUS.DEFAULT_3DWAY
    }
  })
  return cards
}


private async doFullAuth(currentUser: User): Promise<void> {
  this.currentUser = currentUser;
  const authToken = await this.currentUser.getIdToken();
  // this.rollbar.info(`Full auth happened, user: ${this.currentUser.uid}`);
  await this.getSignedCookieForGCS(authToken);
  console.log(`Full auth happened, user: ${this.currentUser.uid}`)
}

  private async getSignedCookieForGCS(authToken: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + authToken,
        }),
        reportProgress: true,
        withCredentials: true
      };
      lastValueFrom(this.http.get(environment.endpoints.authUrl, httpOptions))
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
        console.error(err);
        this.firebaseAuth.clearLocalStorageData();
        this.settingsService.showToastMsg(err);
      })
    });
  }

  public getCollectionCardSourceByTitle(contentUrl: string): ICardCollection {
    const requiredCollection = this.feedCollectionCardsSource.find((cardToCheck) => {
      return cardToCheck.collectionContentMobile === contentUrl;
    })
    return requiredCollection;
  }

  public getCollectionFeedCardsById(id: string): ICard[] {
    const requiredCollection = this.feedCollectionCardsSource.find((cardToCheck) => {
      return cardToCheck.collectionId === id;
    })
    return requiredCollection.collectionCards;
  }

  public getCollectionFromHomeFeedById(id: string): ICardCollection {
    const requiredCollection = this.feedCollectionCardsSource.find((cardToCheck) => {
      return cardToCheck.collectionId === id;
    })
    return requiredCollection
  }

  public setLastCollectionCard(collectionCard: ICard): void {
    this.lastCollectionCard = collectionCard;
  }

  public getLastCollectionCard(): ICard {
    return this.lastCollectionCard;
  }

  public resetCardService(): void {
    this.currentVisibleCard = undefined;
    this.preloadCardsArray = [];
    this.cardProgressStats = [];
  }

  public setCurrentCard(card: ICard): void {
    console.log(card.cardTitle, ' ', performance.now());
    if (this.currentVisibleCard !== card) {
      if (this.currentVisibleCard?.cardType === card.cardType) {
        const changedCards: ICard[] = [];
        changedCards.push(this.currentVisibleCard);
        changedCards.push(card);
        this.onCardChangedInVisibleZone.next(changedCards);
        console.log('card changed!');
        this.userScrolledAtLeastOnce();
      } else {
        console.log('Card types do not match, not firing onCardChangedInVisibleZone');
      }
    }
    this.currentVisibleCard = card;
    this.currentCardSubject.next(this.currentVisibleCard);
  }

  public getCurrentCard(): ICard {
    return this.currentVisibleCard;
  }

  public triggerAppActivated(): void {
    this.onApplicationActivationSubject.next(this.currentVisibleCard);
    console.log('App activated!');

    const now = new Date();

    // Always trigger views refresh on app activation
    this.onViewsRefreshRequested.next();

    if (this.lastTriggered) {
      const timeDifference = now.getTime() - this.lastTriggered.getTime();
      const oneHour = 60 * 60 * 1000;
      const fifteenMinutes = 15 * 60 * 1000;

      // Check if the time difference is greater than 15 minutes or 1 hour
      if (timeDifference > fifteenMinutes) {
        console.log('App was inactive for more than 15 minutes, refreshing auth token...');
        this.firebaseAuth.getUserToken(true).then(() => {
          console.log('Auth token refreshed successfully');
        }).catch(err => {
          console.warn('Could not refresh auth token:', err);
        });
      }

      if (timeDifference > oneHour) {
        this.lastTriggered = now;

        setTimeout(() => {
          console.log('Triggered checking subscription / membership status on app activation');
          this.setSubForStatusSubscription();
        }, 1000); // Small delay to ensure the firebase token is refreshed

        return;
      }
    } else {
      this.lastTriggered = now;
    }
  }

  public triggerMoreBtnSubject(): void {
    this.moreBtnSubject.next(this.currentVisibleCard);
  }

  public triggerLessBtnSubject(): void {
    this.lessBtnSubject.next(this.currentVisibleCard);
  }

  public triggerShowFullscreen(): void {
    this.isFullscreenPreviewVisible = true;
    this.fullscreenPreviewSubject.next(true);
  }

  public triggerHideFullscreen(): void {
    this.isFullscreenPreviewVisible = false;
    this.fullscreenPreviewSubject.next(false);
  }

  public triggerToggleFullscreenSubject(): void {
    this.isFullscreenPreviewVisible = !this.isFullscreenPreviewVisible;
    this.fullscreenPreviewSubject.next(this.isFullscreenPreviewVisible);
  }

  public preloadNextCards(nodesToPreload: HTMLVideoElement[], currentNode: HTMLVideoElement): void {
    this.preloadCardsArray = nodesToPreload;
    if(currentNode.duration && currentNode.buffered.length > 0 && currentNode.buffered.end(0) / currentNode.duration > 0.2) this.startPreload();
  }

  public addCardsToPreload(nodesToPreload: HTMLVideoElement[]): void {
    if (nodesToPreload?.length > 0) {
      nodesToPreload.forEach((nodeToPreload) => {
        this.preloadCardsArray.push(nodeToPreload);
      })

      window.setTimeout(() => {
        this.startPreload();
      }, 100);
      console.log('** PRELOAD ARRAY LENGTH: ', this.preloadCardsArray.length, ' ** ');
    }
  }

  public onVideoLoadFinished(cardLoadProgress: ICardLoadProgress) {
    this.cardProgressStats.push(cardLoadProgress);
    this.startPreload();
  }

  public setPreloadDirection(direction: PRELOAD_DIRECTION): void {
    if(direction === PRELOAD_DIRECTION.BACKWARD) this.isReversePreloadDirectionSet = true
    else this.isReversePreloadDirectionSet = false;
  }

  public startPreload(): void {
    if (!this.preloadCardsArray) return;
    const videoArray = this.preloadCardsArray.slice();
    for (const video of videoArray) {
      if (isNaN(video.duration) || video.buffered.length === 0 || video.buffered.end(0) < video.duration * 0.95) {
        video.play().catch((err) => {
          console.warn(err);
        });
        console.log('** CARD THAT STARTED TO PRELOAD: ', video?.src, video.classList.toString());
        window.setTimeout(() => {
          if (this.currentVisibleCard?.cardContentMobile !== video.currentSrc) {
            video.pause();
          }
        }, 25);
        break;
      }
    }
  }

  public async getHrefUsdzSample(): Promise<string> {
    return this.firebaseAuth.getDownloadUrl(this.mockDataService.sampleUSDZmodelGSpathPreview)
  }

  public async setRenderLimit(userId: string, renderLimit: number): Promise<any> {
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = {
      'user_id': userId,
      'render_limit': renderLimit
    };
    let response;
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.upload}/set_render_limit`, postBody, this.getRequestOptions(userToken)));
      this.firebaseAuth.setRenderLimitCache(renderLimit);
      console.log('Render limit set successfully: ', response);
    } catch (error) {
      console.log('setRenderLimit ERROR FULL: ', JSON.stringify(error));
      const errMsg = error?.error?.status || error.error;
      console.log('setRenderLimit ERROR: ', errMsg);
      throw new Error(errMsg);
    }

    return response;
  }

  public async getStripeSubscriptions(): Promise<any> {
    const userToken = await this.firebaseAuth.getUserToken();
    let response
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.purchaseWeb}/get_stripe_subscriptions`, {}, this.getRequestOptions(userToken)));
      console.log('response get_stripe_subscriptions', response)
    } catch (error) {
      if(error?.error?.error) {
        console.log('get_stripe_subscriptions: ', error.error.error);
        return error.error.error;
      } else return JSON.stringify(error.error) as any;
    }
    return response
  }

  public async createCheckOutSession(): Promise<any> {
    const uid = await this.firebaseAuth.getUserUid();
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = {
      'prices': this.stripeSubscriptionPrices,
      'quantity':1,
      'user_id': uid,
      'paymentMethodTypes':[
         'card'
      ]
   }
   console.log('postBody: ', postBody);
    let response: any = await lastValueFrom(this.http.post(`${environment.endpoints.purchaseWeb}/create-checkout-session-embeded`, postBody, this.getRequestOptions(userToken)));
    if(response === null) response = [];
    console.log('createCheckOutSession ', response);
    return response
  }

  public async stripeCancelSubscription(): Promise<any> {
    const uid = await this.firebaseAuth.getUserUid();
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = {
      'user_id': uid,
   }
   let response;
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.purchaseWeb}/cancel_stripe_subscription`, postBody, this.getRequestOptions(userToken)));
      console.log('stripeCancelSubscription ', response);
      this.utilityService.showImportantSnackBar('Your membership autorenew cancelled', 100);
      return response
    } catch (error) {
      const errMsg = error?.error?.status  || error.error;
      console.log('stripeCancelSubscription ERROR: ', errMsg);
      throw new Error(errMsg); // throw new error
    }

  }

  public async stripeRenewSubscription(): Promise<any> {
    const uid = await this.firebaseAuth.getUserUid();
    const userToken = await this.firebaseAuth.getUserToken();
    let response;
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.purchaseWeb}/renew_stripe_subscription`, { 'user_id': uid }, this.getRequestOptions(userToken)));
      console.log('stripeRenewSubscription ', response);
      this.utilityService.showImportantSnackBar('Your membership renewed', 100);
      return response
    } catch (error) {
      const errMsg = error?.error?.status || error.error;
      console.log('stripeRenewSubscription ERROR: ', errMsg);
      throw new Error(errMsg); // throw new error
    }
  }

  public async startStripeOnboarding(userId?: string): Promise<{ stripeAccountId: string; onboardingUrl: string }> {
    const uid = userId ?? await this.firebaseAuth.getUserUid();
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = { user_id: uid };
    let response;
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.purchaseWeb}/start-onboarding`, postBody, this.getRequestOptions(userToken)));
      return response as { stripeAccountId: string; onboardingUrl: string };
    } catch (error) {
      const errMsg = error?.error?.status || error.error;
      console.log('startStripeOnboarding ERROR: ', errMsg);
      throw new Error(errMsg);
    }
  }


  private getRequestOptionsAnonymous(): any {
    return {
      headers: new HttpHeaders({ 'Accept': 'application/json' }),
      withCredentials: true
    };
  }

  private getRequestOptions(token: string): any {
    return {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      }),
      reportProgress: true,
      withCredentials: true,
    };
  }

  // PUBLISH !!!
  public async sendToReviewModelPostRequest(card: ICard): Promise<any> {
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = { model_id: card.id };

    let response
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.contentReview}/create_review`, postBody, this.getRequestOptions(userToken)));
      this.utilityService.showSnackBar('Models successfully sent to review', 0);
      console.log('response sendToReviewModelPostRequest', response);
    } catch (error) {
      const errMsg = error?.error?.status  || error.error;
      console.log('sendToReviewModelPostRequest ERROR: ', errMsg);
      throw new Error(errMsg); // throw new error
    }

    return response
  }

  public async publishModelsPostRequest(models: string[], userId?: string): Promise<any> {
    const uid = userId ?? await this.firebaseAuth.getUserUid();
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = { models, user_id: uid };

    let response
    try {
      response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/publish`, postBody, this.getRequestOptions(userToken)));
      this.utilityService.showSnackBar('Publish request sent', 0);
      console.log('response publishModelsPostRequest', response);
    } catch (error) {
      const errMsg = error?.error?.status  || error.error;
      console.log('publishModelsPostRequest ERROR: ', errMsg);
      throw new Error(errMsg);
    }

    return response
  }

  public async getUserReviewPublishRejectModelById(modelId: string): Promise<any> {
    const userToken = await this.firebaseAuth.getUserToken();
    const postBody = {
      'public_model_id': modelId,
      'model_id': modelId,
    }

    const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.contentReview}/get_review_by_public_model_id`, postBody, this.getRequestOptions(userToken)));
    console.log('getUserReviewPublishRejectModelById Recieved : ', response);
    return response
    }

    public async cancelReviewModelPostRequest(model?: ICard): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();
      const postBody = {
        'public_model_id': model?.publicModelId || model?.id,
        'model_id': model?.id
      }

      const response = await lastValueFrom(this.http.post(`${environment.endpoints.contentReview}/del_review`, postBody, this.getRequestOptions(userToken)));

      return response
    }

    public async rejectReviewModelPutRequest(model?: ICard): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const postBody = {
        public_model_id: model?.publicModelId || model?.id,
        model_id: model?.id,
        status: 'rejected'
      };

      const response = await lastValueFrom(this.http.put(`${environment.endpoints.contentReview}/upd_review`, postBody, this.getRequestOptions(userToken)));

      return response
    }

    public async markRejectionViewed(reviewId: string): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();
      const postBody = {
        user_id: uid,
        review_id: reviewId,
      };

      return lastValueFrom(
        this.http.post(`${environment.endpoints.contentReview}/rejection_viewed`, postBody, this.getRequestOptions(userToken))
      );
    }

    public async getAllUserLikes(): Promise<ILikedUserData> {
      const uid = await this.firebaseAuth.getUserUid();
      const userToken = await this.firebaseAuth.getUserToken();

      const postBody = {'user_id': uid}

      const response: any = await lastValueFrom(this.http.post<LikesResponseDto>(`${environment.endpoints.webBackend}/likes`, postBody, this.getRequestOptions(userToken)));
      const processedResponse: ILikedUserData = {
         user_id: response.user_id ? response.user_id : '',
         liked_collections: response.collections_likes ? processCollectionDtoResponse(response.collections_likes) : [],
         liked_models: response.models_likes ? this.processCardsFromDtoHomeFeed(response.models_likes, undefined) : []
      }
      console.log('getAllUserLikes Recieved : ', response);
      return processedResponse
    }

    public async setUserLike(model: ICard | ICardCollection): Promise<any> {
      const uid = await this.firebaseAuth.getUserUid();
      const userToken = await this.firebaseAuth.getUserToken();

      let body;
      if (typeof model === 'object' && 'cardContentMobile' in model) {
        body = {
          'item_id': model.id,
          'item_type': CARD_TYPE.MODEL,
          'user_id': uid,
        }
      }
      if (typeof model === 'object' && 'collectionId' in model) {
        body = {
          'item_id': model.collectionId,
          'item_type': CARD_TYPE.COLLECTION,
          'user_id': uid,
        }
      }

      let response;
      try {
        response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/like`, body, this.getRequestOptions(userToken)));
      } catch (error) {
        console.log('ERROR setUserLike;')
        console.log(error)
        if (error.error) this.utilityService.showErrorSnackBar(JSON.stringify(error.error), 1500)
        else this.utilityService.showErrorSnackBar(JSON.stringify(error), 1500);
        throw error;
      }
      return response
    }

    public async removeUserLike(model: ICard | ICardCollection ): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();

      let body;
      if(typeof model === 'object' && 'cardContentMobile' in model) {
        body = {
          'item_id': model.id,
          'item_type' : CARD_TYPE.MODEL,
          'user_id': uid,
        }
      }
      if(typeof model === 'object' && 'collectionId' in model) {
        body = {
          'item_id': model.collectionId,
          'item_type' : CARD_TYPE.COLLECTION,
          'user_id': uid,
        }
      }
      const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/dislike`, body,  this.getRequestOptions(userToken)));
      console.log('removeUserLike Recieved : ', response);
      return response
    }

    public async getHomeFeed(options: { unauth?: boolean } = {}): Promise<ICardCollection[]> {
      const { unauth } = options;
      let response: any;

      if(unauth) {
        response = await lastValueFrom(this.http.get(`${environment.endpoints.webBackend}/home_feed`, this.getRequestOptionsAnonymous()))
      } else {
        const userToken = await this.firebaseAuth.getUserToken();
        response = await lastValueFrom(this.http.get(`${environment.endpoints.webBackend}/home_feed`, this.getRequestOptions(userToken)));

      }
      const processedResponse = processCollectionDtoResponse(response);
      console.log('getHomeFeed Recieved : ', response);
      return processedResponse
    }

    public async getUserUploadedModels(userId: string): Promise<ICard[]> {
      const userToken = await this.firebaseAuth.getUserToken();
      let response;
      try {
        response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/all_user_uploaded_models`, { 'user_id': userId }, this.getRequestOptions(userToken)));
        if (response === null) response = [];
      } catch (error) {
        console.log(error)
        if (error.error) this.utilityService.showErrorSnackBar(JSON.stringify(error.error), 1500)
        else this.utilityService.showErrorSnackBar(JSON.stringify(error), 1500);
      }

      const normalizedResponse = this.normalizeDtoCardsLifecycleStatuses(response, {
        fallbackToStatus: false,
        defaultStatus: CARD_PURCHASE_STATUS.UPLOADED,
      });

      const processedResponse = await this.processCardsFromDtoAsyncWithDownloadLink(normalizedResponse);
      processedResponse.sort((a, b) => b.modifiedDate.localeCompare(a.modifiedDate));

      console.log('getListOfUserUploadedModels Download: ', processedResponse);
      return processedResponse;
    }

    public async createCollectionPostRequest(collection?: ICardCollection): Promise<any> {
      const uid = await this.firebaseAuth.getUserUid();
      const userToken = await this.firebaseAuth.getUserToken();

      collection.collectionAuthor = uid;
      const postBody = { ...convertCollectionToDtoCollection(collection) } as any

      let response
      try {
        response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/create_collection`, postBody, this.getRequestOptions(userToken)));
        console.log('response createCollectionPostRequest', response)
      } catch (error) {
        if (error?.error?.error) {
          console.log('createCollectionPostRequest ERROR: ', error.error.error);
          return error.error.error;
        } else return JSON.stringify(error.error) as any;
      }
      return response
    }

    public async initAiCollectionPostRequest(request: AiCollectionInitRequestDto): Promise<AiCollectionInitResponseDto> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = request?.user_id || await this.firebaseAuth.getUserUid();
      const normalizedAssets = (request?.assets || [])
        .filter((asset) => !!asset && typeof asset === 'object')
        .map((asset, index) => ({
          asset_id: `${asset.asset_id || ''}`.trim(),
          title: `${asset.title || ''}`.trim(),
          position: Number.isFinite(asset.position) ? Number(asset.position) : index,
          original_url_web: `${asset.original_url_web || ''}`.trim(),
          original_url_app: `${asset.original_url_app || ''}`.trim(),
        }))
        .filter((asset) => {
          return !!asset.asset_id
            && !!asset.title
            && !!asset.original_url_web
            && !!asset.original_url_app;
        });

      if (normalizedAssets.length === 0) {
        throw new Error('initAiCollectionPostRequest: no valid assets provided');
      }

      const postBody = {
        user_id: uid,
        title: `${request?.title || 'AI Collection'}`.trim() || 'AI Collection',
        assets: normalizedAssets,
      };

      const requestOptions = {
        headers: new HttpHeaders({
          'Accept': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        }),
      };
      const response = await lastValueFrom(
        this.http.post<AiCollectionInitResponseDto>(
          `${environment.endpoints.webBackend}/ai-collection/init`,
          postBody,
          requestOptions,
        )
      );
      console.log('initAiCollectionPostRequest response: ', response);
      return response;
    }

    public async shareDataRequest(originalId: string, dataType: 'model' | 'collection'): Promise<any> {
      try {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();
      const postBody = {
        user_id: uid,
        'original_id': originalId,
        'type': dataType
      };
      const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/share_data`, postBody, this.getRequestOptions(userToken)));
      console.log('shareModelRequest Received: ', response);
      return response;
      } catch (error) {
      const errorCode = error?.status || error?.error?.status || error?.code || 'Unknown';
      const isBackendUnavailable = Number(errorCode) === 503;
      const isCorsNetworkFailure = Number(errorCode) === 0;
      const message = isBackendUnavailable
        ? 'Sharing service is temporarily unavailable (503). Please try again later.'
        : isCorsNetworkFailure
          ? 'Sharing request failed due to network/CORS error. Please try again later.'
          : `An error occurred while sharing data (Error code: ${errorCode}). Please try again later.`;

      this.utilityService.showImportantErrorSnackBar(message, 700, undefined, {
        endpoint: `${environment.endpoints.webBackend}/share_data`,
        originalId,
        dataType,
        error,
      });
      throw error;
      }
    }

    public async getDownloadSourceLink(modelId: string): Promise<any> {
      // Remove hardcoded model ID and use the provided one LATER; teapot1745856113843
      const postBody = {
        'model_id': modelId,
      };
      const userToken = await this.firebaseAuth.getUserToken();
      const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/source_link`, postBody, this.getRequestOptions(userToken)));
      console.log('getDownloadSourceLink Recieved : ', response);
      const link = response.download_link;
      return link;
    }


    public async getSharedDataById(sharedDataUid: string, type: string): Promise<ICardCollection | ICardExtended> {
      const postBody = {
        'share_id': sharedDataUid,
        type
      };
      const response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/get_shared_data_by_id`, postBody, this.getRequestOptionsAnonymous()));
      console.log('getSharedDataRequest Recieved : ', response);

      if (type === 'collection') {
        const collectionResponse: DtoICollection =  response as unknown as DtoICollection;
        const collectionModels = Array.isArray(collectionResponse?.collection_models)
          ? collectionResponse.collection_models
          : [];
        collectionModels.forEach((model) => {
          model.review_status = CARD_PURCHASE_STATUS.DEFAULT_3DWAY;
        });
        collectionResponse.collection_models = collectionModels;
        return processDraftCollectionDtoResponse([collectionResponse])[0];
      } else if (type === 'model') {
        const modelResponse: DtoICard = response as unknown as DtoICard;
        modelResponse.review_status = CARD_PURCHASE_STATUS.DEFAULT_3DWAY;
        console.log('dto', this.processExtendedCardsFromDto([modelResponse])[0])
        return this.processExtendedCardsFromDto([response as unknown as DtoICard])[0];
      } else {
        console.error('Unknown response format:', response);
        throw new Error('Unexpected response format from getSharedDataById');
      }
    }

    public async getReviewsCardsByStatus(reviewStatus: string): Promise<ModelCardRenderedSelection[]> {
      const params = new HttpParams().set('review_status', reviewStatus);
      const userToken = await this.firebaseAuth.getUserToken();

      const response = await lastValueFrom(
        this.http.get(`${environment.endpoints.contentReview}/reviews`, {
          ...this.getRequestOptions(userToken),
          params,
        })
      );

      const cardsDto = this.extractReviewsCardsDto(response);
      const processedCards = await this.processCardsFromDtoAsyncWithDownloadLink(cardsDto);
      return processedCards as ModelCardRenderedSelection[];
    }

    public async getUserAllReviews(userId: string): Promise<any[]> {
      const userToken = await this.firebaseAuth.getUserToken();

      try {
        const payload = {
          user_id: userId
        };

        const response: any = await lastValueFrom(
          this.http.post(`${environment.endpoints.contentReview}/user_reviews`, payload, {
            ...this.getRequestOptions(userToken)
          })
        );

        return Array.isArray(response) ? response : (response?.reviews ?? response?.data ?? []);
      } catch (error) {
        console.warn('Failed to fetch user reviews for enrichment', error);
        return [];
      }
    }

    public async getPublicStorePublishedCards(): Promise<ModelCardRenderedSelection[]> {
      const response = await lastValueFrom(
        this.http.get(`${environment.endpoints.contentReview}/store`, this.getRequestOptionsAnonymous())
      );

      const publishedCardsDto = this.extractReviewsCardsDto(response).filter((dtoCard) => {
        const reviewStatus = this.resolveLifecycleReviewStatus(dtoCard, {
          fallbackToStatus: true,
        });
        return reviewStatus === CARD_PURCHASE_STATUS.PUBLISHED;
      });

      const processedCards = await this.processCardsFromDtoAsyncWithDownloadLink(publishedCardsDto);
      return processedCards as ModelCardRenderedSelection[];
    }

    private extractReviewsCardsDto(response: any): DtoICard[] {
      const source = Array.isArray(response)
        ? response
        : response?.reviews ?? response?.data ?? [];

      return this.normalizeDtoCardsLifecycleStatuses(source, {
        fallbackToStatus: true,
      });
    }

    private normalizeDtoCardsLifecycleStatuses(
      source: unknown,
      options: { fallbackToStatus?: boolean; defaultStatus?: string } = {}
    ): DtoICard[] {
      if (!Array.isArray(source)) {
        return [];
      }

      return source
        .filter((item) => item && typeof item === 'object')
        .map((item) => {
          const nextItem = { ...(item as Record<string, unknown>) };
          const reviewStatus = this.resolveLifecycleReviewStatus(nextItem as Partial<DtoICard>, options);

          if (reviewStatus) {
            nextItem.review_status = reviewStatus;
          }

          return nextItem as unknown as DtoICard;
        });
    }

    private resolveLifecycleReviewStatus(
      dtoItem: Partial<DtoICard>,
      options: { fallbackToStatus?: boolean; defaultStatus?: string } = {}
    ): string {
      const { fallbackToStatus = true, defaultStatus = '' } = options;
      const candidateStatuses: unknown[] = [dtoItem.review_status, dtoItem.model_review_status];

      if (fallbackToStatus) {
        candidateStatuses.push(dtoItem.status);
      }

      const selectedStatus = candidateStatuses.find((value) => {
        if (value === null || value === undefined) return false;
        const normalized = `${value}`.trim().toLowerCase();
        return normalized !== '' && normalized !== 'null' && normalized !== 'undefined';
      });

      if (selectedStatus === undefined) {
        return defaultStatus;
      }

      const normalizedReviewStatus = this.normalizeReviewStatusValue(`${selectedStatus}`);
      return normalizedReviewStatus || defaultStatus;
    }

    private normalizeReviewStatusValue(status?: string): string {
      if (status === undefined || status === null) return '';
      const normalizedStatus = `${status}`.trim().toLowerCase();
      if (!normalizedStatus || normalizedStatus === 'null' || normalizedStatus === 'undefined') return '';

      const statusMap: Record<string, string> = {
        'in-review': CARD_PURCHASE_STATUS.IN_REVIEW,
        'in_review': CARD_PURCHASE_STATUS.IN_REVIEW,
        'review-publish-reject': CARD_PURCHASE_STATUS.REVIEW_PUBLISH_REJECT,
        'review_publish_reject': CARD_PURCHASE_STATUS.REVIEW_PUBLISH_REJECT,
        'uploaded': CARD_PURCHASE_STATUS.UPLOADED,
        'rejected': CARD_PURCHASE_STATUS.REJECTED,
        'published': CARD_PURCHASE_STATUS.PUBLISHED,
        'purchased': CARD_PURCHASE_STATUS.PURCHASED,
        'liked': CARD_PURCHASE_STATUS.DRAFT_LIKED,
      };
      return statusMap[normalizedStatus] || normalizedStatus;
    }

    public async sendFeedbackRequest(text: string, debugData: string = ''): Promise<any> {
      const uid = await this.firebaseAuth.getUserUid();
      const userToken = await this.firebaseAuth.getUserToken();

      const postBody = {
        'user_id': uid,
        text,
        'debug_data': debugData
      };

      let response;
      try {
        response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/feedback`, postBody, this.getRequestOptions(userToken)));
        console.log('sendFeedbackRequest response: ', response);
        this.utilityService.showSnackBar('Feedback sent successfully', 0);
      } catch (error) {
        const errMsg = error?.error?.status || error.error;
        console.log('sendFeedbackRequest ERROR: ', errMsg);
        this.utilityService.showErrorSnackBar('Failed to send feedback', 1500);
        throw new Error(errMsg);
      }

      return response;
    }

    public async getUserDraftCollections(): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();
      const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/user_collections`, { 'user_id': uid }, this.getRequestOptions(userToken)));
      console.log('getUserCollections Recieved : ', response);
      return processDraftCollectionDtoResponse(response)
    }

    public async getModelById(modelId: string): Promise<ICard[]> {
      const userToken = await this.firebaseAuth.getUserToken();
      const postBody = {'model_id': modelId};
      const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/get_model`, postBody, this.getRequestOptions(userToken)));
      console.log('getModelById : ', this.processCardsFromDtoHomeFeed([response], ''));
      return this.processCardsFromDtoHomeFeed([response], '')
    }

    public async getCollectionByIdRequest(collecetionId: string): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const postBody = {'collection_id': collecetionId}
      const response: any = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/get_collection`, postBody, this.getRequestOptions(userToken)));
      console.log('getCollectionByIdRequest Recieved : ', response);
      return processDraftCollectionDtoResponse([response])
  }

    public async deleteUserCollection(collectionId: string): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const postBody = {'collection_id': collectionId}

      const response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/del_collection`, postBody, this.getRequestOptions(userToken)));
      return response
    }

    public async updateCollectionPostRequest(collection?: ICardCollection): Promise<any> {
      const uid = await this.firebaseAuth.getUserUid();
      const userToken = await this.firebaseAuth.getUserToken();
      collection.collectionAuthor = uid;
      const postBody = { ...convertCollectionToDtoCollection(collection) } as any

      const response = await lastValueFrom(this.http.put(`${environment.endpoints.webBackend}/upd_collection`, postBody, this.getRequestOptions(userToken)));
      return response
    }


    public async deleteModelPostRequest(model?: ICard): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const postBody = {...convertCardsToDtoCards([model])[0]}

      const response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/del_model`, postBody, this.getRequestOptions(userToken)));
      return response
    }

    public async deleteOwnedModelPostRequest(model?: ICard): Promise<any> {
      if (!model) {
        throw new Error('deleteOwnedModelPostRequest: model is required');
      }

      if (model.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED) {
        // Rejected models still carry review state; remove the review before deleting the upload itself.
        await this.cancelReviewModelPostRequest(model);
        return this.deleteModelPostRequest({ ...model, purchaseStatus: CARD_PURCHASE_STATUS.UPLOADED });
      }

      return this.deleteModelPostRequest(model);
    }

    public async updateModelPostRequest(model?: ICard): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const postBody = {...convertCardsToDtoCards([model])[0]}

      const response = await lastValueFrom(this.http.put(`${environment.endpoints.webBackend}/update_model`, postBody, this.getRequestOptions(userToken)));
      return response
    }

    public async disableUserRequest(): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();
      const requestHeader = this.getRequestOptions(userToken);
      requestHeader.headers = requestHeader.headers.append('X-Firebase-Token', userToken);

      const response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/remove_user`, {'user_id': uid }, requestHeader));
      return response
    }

    public async stopRenderPostRequest(modelId): Promise<any> {
      const requestOptions = this.getRequestOptions(await this.firebaseAuth.getUserToken());
      const uid = await this.firebaseAuth.getUserUid();
      const postBody = { user_id: uid, model_id: modelId };
      const response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/stop_render`, postBody, requestOptions));
      console.log('response stopRenderRequest', response);
      return response
    }

    public async triggerModelRenderPostRequest(modelId: string, fullModelPath: string): Promise<any> {
      const requestOptions = this.getRequestOptions(await this.firebaseAuth.getUserToken());
      const uid = await this.firebaseAuth.getUserUid();
      const postBody = {
        user_id: uid,
        model_id: modelId,
        full_model_path: fullModelPath
      };
      const response = await lastValueFrom(this.http.post(`${environment.endpoints.webBackend}/render`, postBody, requestOptions));
      console.log('response triggerModelRenderPostRequest', response);
      return response;
    }

    public async activateTrialPostRequest(): Promise<any> {
      const userToken = await this.firebaseAuth.getUserToken();
      const uid = await this.firebaseAuth.getUserUid();
      const response = await lastValueFrom(this.http.post(`${environment.endpoints.upload}/activate_trial`, { user_id: uid }, this.getRequestOptions(userToken)));
      console.log('response activateTrialPostRequest', response);
      return response
    }

    public async getUserSubscriptionStatusRequest(): Promise<any> {
      const uid = await this.firebaseAuth.getUserUid();
      let userToken = await this.firebaseAuth.getUserToken();
      let response;
      try {
        response = await lastValueFrom(this.http.post(`${environment.endpoints.upload}/subscription_status`, { user_id: uid}, this.getRequestOptions(userToken)));
        console.log('response getUserSubscriptionStatusRequest', response);
      } catch (error) {
        console.log('getUserSubscriptionStatusRequest ERROR FULL: ', JSON.stringify(error));
        if (error?.code === 205 || (typeof error === 'object' && JSON.stringify(error).includes('"code":205'))) {
          console.log('Token expired, trying to refresh and retry...');
          try {
            userToken = await this.firebaseAuth.getUserToken(true);
            response = await lastValueFrom(this.http.post(`${environment.endpoints.upload}/subscription_status`, { user_id: uid}, this.getRequestOptions(userToken)));
            console.log('Retry successful after token refresh');
            return response;
          } catch (retryError) {
            console.log('Retry failed after token refresh: ', JSON.stringify(retryError));
            const retryErrMsg = retryError?.error?.status || retryError.error;
            throw new Error(retryErrMsg);
          }
        }
        const errMsg = error?.error?.status || error.error;
        throw new Error(errMsg);
      }
      return response;
    }

      public async getDataFromAiDescription(cardOrCollection: ICard | ICardCollection, aiProvider: 'gemini' | 'openai' = 'gemini', customModel?: string, thinkingBudget?: number): Promise<IAiDescriptionResponse> {
        this.isLongResponseLoading = true; // Set loading to true

        const makeRequest = async (): Promise<IAiDescriptionResponse> => {
          // Get settings for AI analysis
          let customPrompt = this.settingsService.getAiPromptFromLocalstorage();
          const framesCount = this.settingsService.getAiFramesCountFromLocalstorage();
          const temperature = this.settingsService.getAiTemperatureFromLocalstorage();
          const finalThinkingBudget = thinkingBudget || this.settingsService.aiThinkingBudget || 4000;

          // Determine if it's a collection or single card
          const isCollection = 'collectionCards' in cardOrCollection;
          let requestBody: any;

          if (isCollection) {
            // Handle collection - extract URLs from all cards
            const collection = cardOrCollection as ICardCollection;
            const urls = collection.collectionCards
              .filter(card => card.cardContentWeb || card.cardContentMobile)
              .map(card => card.cardContentWeb || card.cardContentMobile)

            // If no custom prompt provided, generate one based on frames count
            if (!customPrompt || customPrompt === this.settingsService.getDefaultAiPrompt()) {
              customPrompt = this.settingsService.getAiPromptForFramesCount(framesCount, true);
            }

            requestBody = {
              imageUrls: urls,
              prompt: customPrompt,
              framesCount,
              provider: aiProvider,
              temperature,
              customModel,
              thinkingBudget: finalThinkingBudget
            };
          } else {
            // Handle single card - simplified logic for AI Analysis Table
            const card = cardOrCollection as ICard;
            const fileUrl = card.cardContentWeb || card.cardContentMobile;

            // If no custom prompt provided, generate one based on frames count
            if (!customPrompt || customPrompt === this.settingsService.getDefaultAiPrompt()) {
              customPrompt = this.settingsService.getAiPromptForFramesCount(framesCount, false);
            }

            // Simple: always send as imageUrl, backend detects video/image by extension
            requestBody = {
              imageUrl: fileUrl,
              prompt: customPrompt,
              framesCount,
              provider: aiProvider,
              temperature,
              customModel,
              thinkingBudget: finalThinkingBudget
            };
          }

          console.log(`Using AI Provider: ${aiProvider.toUpperCase()}`);

          // Use lastValueFrom to convert the observable to a promise
          const response = await lastValueFrom(
            this.http.post('https://web-dev.corp.3dway.io/genAiDescription',
            // this.http.post('http://127.0.0.1:5001/data-dev-dwayllc/us-central1/genAiDescription',
              requestBody,
              { responseType: 'text' }
            )
          );

          // Parse JSON response
          try {
            let cleanResponse = response as string;

            // Remove markdown code block wrapper if present
            if (cleanResponse.includes('```json')) {
              const jsonStart = cleanResponse.indexOf('```json') + 7;
              const jsonEnd = cleanResponse.lastIndexOf('```');
              if (jsonEnd > jsonStart) {
                cleanResponse = cleanResponse.substring(jsonStart, jsonEnd).trim();
              }
            }

            // Also handle case where response starts with ```json without newline
            cleanResponse = cleanResponse.replace(/^```json\s*/, '').replace(/\s*```$/, '');

            console.log('Cleaned response for parsing:', cleanResponse);

            const aiResponse: IAiDescriptionResponse = JSON.parse(cleanResponse);

            // Validate response structure
            if (!aiResponse.short_description || !aiResponse.technical_description || !aiResponse.model_name) {
              throw new Error('Invalid AI response structure');
            }

            return aiResponse;
          } catch (parseError) {
            console.error('Failed to parse AI response as JSON:', parseError);
            console.log('Raw response:', response);

            // Try to extract JSON from text response if it's wrapped in markdown
            const rawResponse = response as string;
            try {
              // Look for JSON pattern in the text
              const jsonMatch = rawResponse.match(/\{[\s\S]*\}/);
              if (jsonMatch) {
                const extractedJson = jsonMatch[0];
                console.log('Extracted JSON:', extractedJson);
                const aiResponse: IAiDescriptionResponse = JSON.parse(extractedJson);

                if (aiResponse.model_name && aiResponse.short_description && aiResponse.technical_description) {
                  return aiResponse;
                }
              }
            } catch (extractError) {
              console.warn('Failed to extract JSON from response:', extractError);
            }

            // Final fallback: create structured response from text
            const fallbackResponse: IAiDescriptionResponse = {
              model_name: 'Unknown Model',
              short_description: rawResponse.substring(0, 250),
              technical_description: rawResponse
            };

            return fallbackResponse;
          }
        };        // First attempt
        try {
          console.log('Making first AI request...');
          return await makeRequest();
        } catch (error) {
          console.warn('First AI request failed, error details:', {
            name: error.name,
            message: error.message,
            status: error.status,
            statusText: error.statusText,
            error: error.error,
            fullError: error
          });

          // Wait 10 seconds
          console.log('Waiting 10 seconds before retry...');
          await new Promise(resolve => setTimeout(resolve, 10000));

          // Second attempt
          try {
            console.log('Retrying AI request...');
            return await makeRequest();
          } catch (retryError) {
            console.error('Second AI request failed, error details:', {
              name: retryError.name,
              message: retryError.message,
              status: retryError.status,
              statusText: retryError.statusText,
              error: retryError.error,
              fullError: retryError
            });
            this.utilityService.showImportantErrorSnackBar(`Error fetching AI description: ${retryError.error || retryError.message}`, 0);
            throw retryError; // Re-throw the error from the second attempt
          }
        } finally {
          this.isLongResponseLoading = false; // Reset loading state
        }
      }

  public processCardsFromDtoHomeFeed(cardsDto: DtoICard[], parentCollectionId: string): ICardExtended[] {
    return processCardsDtoUnified(cardsDto, { parentCollectionId });
  }

  public processUserCardsFromDraftCollection(cardsDto: DtoICard[], parentCollectionId: string): ICardExtended[] {
    return processCardsDtoUnified(cardsDto, { parentCollectionId });
  }

  public processExtendedCardsFromDto(cardsDto: DtoICard[]): ICardExtended[] {
    return processCardsDtoUnified(cardsDto);
  }

  public async processCardsFromDtoAsyncWithDownloadLink(cardsDto: DtoICard[]): Promise<ICardExtended[]> {
    const cards = processCardsDtoUnified(cardsDto, { resolveWithDownloadLink: true });
    return Promise.all(
      cards.map(async card => ({
        ...card,
        cardModelLink: card.cardModelLink ? await this.firebaseAuth.getDownloadUrlRef(card.cardModelLink) : card.cardModelLink,
      }))
    );
  }

  public userKnowsHowToScrollFeed(): boolean {
    return this.firebaseAuth.getFirstTimeScrolledAnyFeed();
  }

  private userScrolledAtLeastOnce(): void {
    this.firebaseAuth.setFirstTimeScrolledAnyFeed(true);
  }

}
